import { createFileRoute, Link } from '@tanstack/react-router';
import { ShieldAlertIcon } from 'lucide-react';
import z from 'zod';

import { Button } from '@components/ui/button';

const unauthorizedSearchSchema = z.looseObject({
  error: z.string().optional(),
  error_description: z.string().optional(),
  reason: z.enum(['google-login-failed']).optional(),
});

export const Route = createFileRoute('/unauthorized')({
  component: Unauthorized,
  validateSearch: search => unauthorizedSearchSchema.parse(search),
});

function Unauthorized() {
  const { error, error_description } = Route.useSearch();

  return (
    <main className="bg-background grid min-h-dvh place-items-center px-6 text-center">
      <div className="grid max-w-md gap-5">
        <ShieldAlertIcon className="text-secondary mx-auto size-12" />
        <div className="grid gap-2">
          <h1 className="text-primary-dark-one dark:text-primary text-3xl font-semibold">
            Unauthorized
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-300">
            We could not sign you in with Google. Please make sure your account
            is allowed to access Fixxer Connect, or contact your administrator.
          </p>
          {(error || error_description) && (
            <p className="text-xs wrap-break-word text-gray-400 dark:text-gray-500">
              {error_description ?? error}
            </p>
          )}
        </div>
        <Button asChild className="mx-auto mt-4 w-fit px-8" variant="secondary">
          <Link to="/">Back to login</Link>
        </Button>
      </div>
    </main>
  );
}
